import React, { useEffect, useState } from 'react';
import { PDFDocument, rgb, StandardFonts } from 'pdf-lib';
import { uploadFilePDF } from "../../Services/AttachFileService";
import useAlert from "../../hooks/useAlert";
import Fontkit from "@pdf-lib/fontkit"
import usefont from "./NotoSansJP-Regular.ttf";
import useThaifont from "./Sarabun-Regular.ttf";

interface UploadPdfComponent {
    buttonType: string;
    pdf: string;
    result: Array<{
        type: 'text' | 'freehand';
        text?: string;
        x?: number;
        y?: number;
        page: number;
        ref: React.RefObject<HTMLDivElement>;
        arr?: Array<{ get: (key: string) => number }>;
    }>;
    bounds: { x: number; y: number };
    resetButtonType: () => void;
    memo: any;
    fileName: any;
    setLoading: any;
}

const UploadPdfComponent: React.FC<UploadPdfComponent> = (props) => {

    const fileName = props?.fileName;
    const { toggleAlert } = useAlert();
    const [lineYPosition, setLineYPosition] = useState<Number>(0);
    const [lineXPosition, setLineXPosition] = useState<Number>(0);

    useEffect(() => {
      const getWidth = Number(localStorage.getItem("pdfEditNewWidth"));
      if (getWidth > 800) {
        setLineYPosition(-40);
        setLineXPosition(230);
      } else if (getWidth > 550) {
        setLineYPosition(-15);
        setLineXPosition(150);
      } else {
        setLineYPosition(-10);
        setLineXPosition(150);
      }
    },[])

    useEffect(() => {
        if (props.buttonType === "download") {
            modifyPdf();
            props.resetButtonType();
        }
    }, [props.buttonType]);

    const uint8ArrayToBase64 = (uint8Array: any) => {
        const binaryString = uint8Array.reduce((data: any, byte: any) => data + String.fromCharCode(byte), '');
        return btoa(binaryString);
    }

    const modifyPdf = async () => {
        props.setLoading(true);
        const existingPdfBytes = await fetch(props.pdf).then(res => res.arrayBuffer());
        const pdfDoc = await PDFDocument.load(existingPdfBytes);
        pdfDoc.registerFontkit(Fontkit)
        const fetchfont = await fetch(usefont).then(res => res.arrayBuffer());
        const fetchThaiFont = await fetch(useThaifont).then(res => res.arrayBuffer());
        const font = await pdfDoc.embedFont(fetchfont);
        const fontThai = await pdfDoc.embedFont(fetchThaiFont);
        const pages = pdfDoc.getPages();

        props.result.forEach((res: any) => {
            if (res?.type === "text" && res.text) {
                const charCode = res.text.charCodeAt(0);
                let selectedFont;
                if (charCode >= 3585 && charCode <= 3675) {
                    selectedFont = fontThai;
                } else if (
                    (charCode >= 12352 && charCode <= 12543) ||
                    (charCode >= 19968 && charCode <= 40959)
                ) {
                    selectedFont = font;
                }
                const pageWidth = pages[res.page - 1].getWidth();
                const pageHeight = pages[res.page - 1].getHeight();
                const parentRect = document.getElementById("drawArea")?.getBoundingClientRect();
                const scaleX = pageWidth / (parentRect?.width || pageWidth);
                const scaleY = pageHeight / (parentRect?.height || pageHeight);
                const textY = pageHeight - res.y + 35;
                const textX = (res.x - (parentRect?.left || 0)) * scaleX + 200;
                pages[res.page - 1].drawText(res.text, {
                    x: textX,
                    y: textY,
                    size: 16,
                    font: selectedFont,
                    color: rgb(0, 0, 1),
                    // color: rgb(0.95, 0.1, 0.1),
                    // maxWidth: res.ref.current.getBoundingClientRect().width,
                    lineHeight: 15
                });
            }
            if (res?.type === "freehand" && res?.arr) {
                const pathData = "M " + res?.arr?.map((p: any) => `${p.get('x') - Number(lineXPosition)},${Number(lineYPosition) + p.get('y')}`).join("L");
                pages[res.page - 1].moveTo(0, pages[0].getHeight());
                pages[res.page - 1].drawSvgPath(pathData, {
                    borderColor: rgb(0, 0, 1),
                    // borderColor: rgb(0.95, 0.1, 0.1),
                    borderWidth: 1,
                });
            }
        });

        const pdfBytes = await pdfDoc.save();
        const toBase64 = uint8ArrayToBase64(pdfBytes);

        const data = {
            MemoId: props.memo.memoid,
            FileName: fileName,
            FileBase64: toBase64,
            connectionString: "",
        }

        const response = await uploadFilePDF(data);
        props.setLoading(false);
        if (response) {
            toggleAlert({
                description: response,
                message: `Upload`,
                type: "success",
            });
        }

        // อย่าลบไว้สำหรับทดสอบ
        // const blob = new Blob([pdfBytes], { type: "application/pdf" });
        // const link = document.createElement('a');
        // link.href = window.URL.createObjectURL(blob);
        // const filePDFName = fileName;
        // link.download = filePDFName;
        // link.click();
        // อย่าลบไว้สำหรับทดสอบ
    }

    return (
        <>
            <div></div>
        </>
    );
};

export default UploadPdfComponent;